const REDUCER = "@CONTENT/";

const actions = {
  GET_LIST_CONTENT: `${REDUCER}GET_LIST_CONTENT`,
  SET_LIST_CONTENT: `${REDUCER}SET_LIST_CONTENT`,
  SET_IS_LOADING: `${REDUCER}SET_IS_LOADING`,
  SET_CURRENT_CONTENT: `${REDUCER}SET_CURRENT_CONTENT`,
};
export default actions;
